import { ServiceBase } from "@app/shared";
import { DocumentTypes } from "./documentTypesEnum";

/** Handles operations for specialty exceptions. */
export default class SpecialtyExceptionsService extends ServiceBase {

  /**
   * Uploads a CMS exception template file.
   * @param documentType The document type.
   * @param file The file to upload.
   */
  public async uploadCmsExceptionTemplate(documentType: DocumentTypes, file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);

    return this.makePost<string>(
      `specialtygroupexceptions/exception-template/${documentType}`,
      formData,
      undefined,
      true,
      false,
      false
    );
  }

  /**
   * Fetches the uploaded document.
   * @param documentType The document type. 
   */
  public async downloadCmsExceptionTemplate(documentType: DocumentTypes): Promise<string> {
    try {
      const response = await this.makeGet<Blob>(
        `specialtygroupexceptions/exception-template/${documentType}`,
        undefined,
        undefined,
        false,
        { responseType: 'blob' }
      );

      return window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
    } catch (error) {
      console.error(`Error fetching document: ${documentType}`, error);
      throw error;
    }
  }
}
